module.exports = __webpack_public_path__ + "img/ic-confirm-warning.e9f379ff.svg";